import { render, staticRenderFns } from "./alternate.vue?vue&type=template&id=46604fb6"
import script from "./alternate.vue?vue&type=script&lang=js"
export * from "./alternate.vue?vue&type=script&lang=js"
import style0 from "./alternate.vue?vue&type=style&index=0&id=46604fb6&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports